import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {Button, Popconfirm, Table} from "antd";
import {Menu as MENU, X} from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";
import {RiEjectLine} from "react-icons/ri";
import {BiCheckDouble} from "react-icons/bi";
import {MdDone, MdFileDownload} from "react-icons/md";
import jsPDF from 'jspdf';

export default function Users() {
    const history = useHistory();
    const [usersData, setUsersData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobileShow, setIsMobileShow] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        LoadUsers();
    }, []);

    const LoadUsers = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "LoadUsers");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Authentication.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setUsersData(result.data);
                            setFilterData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const handleSearch = (value) => {
        if (value) {
            const filtered = filterData.filter((item) => item.FirstName.toLowerCase().includes(value.trim().toLowerCase()) || item.Email.toLowerCase().includes(value.trim().toLowerCase()) || item.PhoneNo.toLowerCase().includes(value.trim().toLowerCase()));
            setUsersData(filtered);
        } else {
            setUsersData(filterData);
        }

    };

    function markAsDone(j, status) {
        let toaster;
        toaster = toast.loading("Processing...");
        try {
            const formdata = new FormData();
            formdata.append("page", "UpdateUserStatus");
            formdata.append("id", j.id);
            formdata.append("email", j.Email);
            formdata.append("status", status);
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            fetch(`${API_LINK}Authentication.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    if (result.status === 1) {
                        setTimeout(() => {
                            toast.update(toaster, {
                                type: "success",
                                render: "User Status Updated!",
                                isLoading: false,
                                autoClose: toaster,
                                closeButton: true,
                                pauseOnHover: false,
                                pauseOnFocusLoss: false,
                            })
                            LoadUsers();
                        }, 1000)
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                })
                .catch(error => console.log('error', error));
        } catch (e) {
            console.log(e);
        }
    }

    const downloadPDF = (record) => {
        const doc = new jsPDF();
        // Add text to PDF for all fields
        doc.text(`First Name: ${record.FirstName}`, 10, 10);
        doc.text(`Last Name: ${record.LastName}`, 10, 20);
        doc.text(`Phone No: ${record.PhoneNo}`, 10, 30);
        doc.text(`Email: ${record.Email}`, 10, 40);
        doc.text(`User Name: ${record.UserName}`, 10, 50);
        doc.text(`Company: ${record.Company}`, 10, 60);
        doc.text(`Address: ${record.Address}`, 10, 70);
        doc.text(`Time Zone: ${record.TimeZone}`, 10, 80);
        doc.text(`Country: ${record.Country}`, 10, 90);
        doc.text(`City: ${record.City}`, 10, 100);
        doc.text(`State: ${record.State}`, 10, 110);
        doc.text(`Zip Code: ${record.ZipCode}`, 10, 120);
        doc.text(`Website: ${record.Website}`, 10, 130);
        doc.text(`Operations: ${record.Operations}`, 10, 140);
        doc.text(`Sector: ${record.Sector}`, 10, 150);
        doc.text(`Date: ${record.Date}`, 10, 160);
        doc.text(`Status: ${record.Status}`, 10, 170);
        // Save the PDF with a meaningful file name
        doc.save(`${record.FirstName}_${record.LastName}_details.pdf`);
    };

    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <h2>Users List</h2>
                    <span>want to manage the users?</span>
                    <div className="content-card">
                        <div className="table-search">
                            <input type="search" placeholder='Type to search...'
                                   onChange={(e) => handleSearch(e.target.value)}/>
                        </div>
                        <Table dataSource={usersData} pagination={{pageSize: 10}}
                               loading={isLoading}
                               rowHoverable={true}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }}/>
                            <Table.Column title="First Name" dataIndex="FirstName"/>
                            <Table.Column title="Last Name" dataIndex="LastName"/>
                            <Table.Column title="UserName" dataIndex="UserName"/>
                            <Table.Column title="Email Address" dataIndex="Email"/>
                            <Table.Column title="Phone No." dataIndex="PhoneNo"/>
                            <Table.Column title="Company" dataIndex="Company"/>
                            <Table.Column title="Address" dataIndex="Address"/>
                            {/*<Table.Column title="Timezone"  dataIndex="TimeZone"/>*/}
                            <Table.Column title="Country" dataIndex="Country"/>
                            <Table.Column title="City" dataIndex="City"/>
                            <Table.Column title="State" dataIndex="State"/>
                            <Table.Column title="Zip Code" dataIndex="ZipCode"/>
                            <Table.Column title="Website" dataIndex="Website"/>
                            <Table.Column title="Company Operations" dataIndex="Operations"/>
                            <Table.Column title="Solar Sector" dataIndex="Sector"/>
                            <Table.Column title="Date" dataIndex="Date"/>
                            <Table.Column title="Status" dataIndex="Status"/>
                            <Table.Column title="PDF" align={'center'} render={(j)=>{
                                return (
                                    <Button type='primary' onClick={()=>{
                                        downloadPDF(j)
                                    }} icon={<MdFileDownload size={15}/>}/>
                                )
                            }}/>
                            {
                                localStorage.getItem("Role") !== "User" &&
                                <>
                                    <Table.Column title="Accept" render={(j) => {
                                        return (
                                            <Popconfirm title={'Are you sure?'}
                                                        description={'You want to mark this user as active?'}
                                                        onConfirm={() => {
                                                            markAsDone(j, "Active")
                                                        }}
                                            >
                                                <Button type='primary' icon={<MdDone size={15}/>}/>
                                            </Popconfirm>
                                        )
                                    }}/>
                                    <Table.Column title="Reject" render={(j) => {
                                        return (
                                            <Popconfirm title={'Are you sure?'}
                                                        description={'You want to reject this user?'}
                                                        onConfirm={() => {
                                                            markAsDone(j, "Rejected")
                                                        }}
                                            >
                                                <Button type='primary' danger icon={<RiEjectLine size={15}/>}/>
                                            </Popconfirm>
                                        )
                                    }}/>
                                </>
                            }


                        </Table>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
